import React from "react";
import LegalPageLayout, { LegalList, LegalSection } from "./LegalPageLayout";
import { SUPPORT_EMAIL } from "../common/SiteFooter";

const Privacy: React.FC = () => (
  <LegalPageLayout title="Privacy Policy" lastUpdated="31 August 2026">
    <p>
      This Privacy Policy explains what personal information Astria collects,
      how we use it, and the choices you have. It applies to our website and
      application.
    </p>

    <LegalSection heading="1. Information We Collect">
      <LegalList
        items={[
          "Account information — your name, email address, mobile number, and date of birth, provided when you register or update your profile.",
          "Birth and profile details — information you voluntarily submit so the Service can generate personalised readings and insights.",
          "Conversation content — the messages and inputs you send to the Service, retained so your history is available to you.",
          "Payment information — processed directly by Stripe. We receive a transaction reference and subscription status, not your full card number.",
          "Technical data — device, browser, and log information collected automatically to keep the Service secure and reliable.",
        ]}
      />
    </LegalSection>

    <LegalSection heading="2. How We Use Your Information">
      <LegalList
        items={[
          "To provide, personalise, and improve the Service.",
          "To create and manage your account and subscription.",
          "To process payments and send billing or transactional notices.",
          "To respond to your support requests.",
          "To detect, prevent, and address fraud, abuse, or technical issues.",
          "To comply with our legal obligations.",
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. Sharing Your Information">
      <p>
        We do not sell your personal information. We share it only with service
        providers who help us operate the Service, and only to the extent
        needed. These include our payment processor (Stripe), our hosting and
        database providers, and the AI providers that generate responses. We may
        also disclose information where required by law.
      </p>
    </LegalSection>

    <LegalSection heading="4. Data Retention">
      <p>
        We retain your information for as long as your account is active, and
        afterwards only as long as necessary to meet legal, accounting, or
        reporting requirements. You may request deletion of your account and
        associated data at any time.
      </p>
    </LegalSection>

    <LegalSection heading="5. Security">
      <p>
        We use appropriate technical and organisational measures to protect your
        information, including encrypted connections and access controls. No
        method of transmission or storage is completely secure, but we work to
        protect your data and to notify you if a breach affecting it occurs.
      </p>
    </LegalSection>

    <LegalSection heading="6. Your Rights">
      <p>
        Depending on where you live, you may have the right to access, correct,
        export, or delete your personal information, to object to or restrict
        certain processing, and to withdraw consent. To exercise any of these
        rights, contact us at {SUPPORT_EMAIL}.
      </p>
    </LegalSection>

    <LegalSection heading="7. Changes to This Policy">
      <p>
        We may update this policy from time to time. Material changes will be
        reflected in the &ldquo;last updated&rdquo; date above, and where
        appropriate we will notify you directly.
      </p>
    </LegalSection>

    <LegalSection heading="8. Contact">
      <p>
        For privacy questions or requests, email{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-[#1B1511] underline underline-offset-4"
        >
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
    </LegalSection>
  </LegalPageLayout>
);

export default Privacy;
